import { TokenAssetBase } from 'types/assetsMetadata';

import { getFtTokenMetadata } from '../api';
import { useFtMetadata } from '../store';

// Ft tokens metadata
const useGetTokenMetadata = () => {
  const { ftMetadata, addMetadata } = useFtMetadata();
  const fetchTokenMetadata = async (
    fullTokenAddress: string,
    ref: string
  ): Promise<TokenAssetBase> => {
    const cashedTokenMetadata = ftMetadata.get(fullTokenAddress);

    if (cashedTokenMetadata) return cashedTokenMetadata;

    const tokenMetadataResponse = await getFtTokenMetadata(fullTokenAddress).catch(() => null);
    if (tokenMetadataResponse?.result) {
      const { name, symbol, decimals } = tokenMetadataResponse.result;

      const newTokenMetadata = {
        name,
        symbol,
        decimals: decimals ?? 0,
        ref,
        address: fullTokenAddress,
        metadata: tokenMetadataResponse.result,
      };

      addMetadata(newTokenMetadata);

      return newTokenMetadata;
    } else {
      return {
        name: ref,
        symbol: ref,
        decimals: 0,
        ref: ref,
        address: fullTokenAddress,
      };
    }
  };

  return { fetchTokenMetadata };
};

export default useGetTokenMetadata;
